import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import { createPinia } from "pinia";
import guardClick from "./directives/guardClick";
import permission from "./directives/permission";

import "./styles/theme.css";
import "./style.css";

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(guardClick);
app.directive("permission", permission);

app.mount("#app");
